module.exports = __webpack_public_path__ + "media/dark-pit.55cf1feb.wav";